import { lazy } from "react";

export const TweetListPage = lazy(() =>
  import("./tweet-list.page").then((m) => ({ default: m.TweetListPage }))
);
